import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useAssetModalPanelContext } from "~/providers/AssetModalPanelContextProvider";
import { Content } from "./Content";
import { ContentHeader } from "./ContentHeader/ContentHeader";
export const AssetModalPanelContainer = /*#__PURE__*/ memo((param)=>{
    let { title, adornment, contentHeader, panel } = param;
    const { hidePanel } = useAssetModalPanelContext();
    return /*#__PURE__*/ _jsxs(Content, {
        children: [
            /*#__PURE__*/ _jsx(ContentHeader, {
                title: title,
                adornment: adornment,
                contentHeader: contentHeader,
                closePanel: hidePanel
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex w-full grow flex-col md:overflow-auto",
                children: panel
            })
        ]
    });
});
AssetModalPanelContainer.displayName = "AssetModalPanelContainer";
